export default {"src":"/_next/static/media/Telegram.ee19fc93.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};